import { Component } from '@angular/core';


@Component({
  selector: 'pagenotfound',
  templateUrl: '../Templates/404.html',
})


export class PageNotFoundComponent {
}



// WEBPACK FOOTER //
// ./src/app/Components/pagenotfound.ts